import { useState, useMemo, useEffect, useCallback } from "react";
import TermsOfUse from "./terms-of-use";
import FunifierWidget from "./funifier/widget";

type GameProps = {
  onQuit: () => void;
};
export default function Game({ onQuit }: GameProps) {
  const [step, setStep] = useState(0);
  const [quizScore, setQuizScore] = useState(0);

  const onReceiveMessage = useCallback((event: MessageEvent) => {
    const receivedMessage = event.data;
    console.log("receivedMessage", receivedMessage);
    if (receivedMessage.message === "quiz-submitted") {
      setQuizScore(receivedMessage.data);
      setStep(2);
    } else if (receivedMessage.message === "scratch-finished") {
      onQuit();
    }
  }, []);

  useEffect(() => {
    console.log("quizScore", quizScore);
  }, [quizScore]);

  useEffect(() => {
    window.addEventListener("message", onReceiveMessage);

    return () => {
      window.removeEventListener("message", onReceiveMessage);
    };
  }, []);

  return useMemo(() => {
    return (
      <>
        {step === 0 ? <TermsOfUse onAccept={() => setStep(1)} /> : null}
        {step === 1 ? <FunifierWidget id="FWQuiz" /> : null}
        {step === 2 ? <FunifierWidget id="FWScratch" /> : null}
      </>
    );
  }, [step]);
}
